import React from "react";

import PriceTag from "./PriceTag";
import {INDETERMINATE} from "./usePriceSummarizer";

import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";



const TabOccupancy = ({formik, ratesViewMode, basePeople, maxOccupancy, minOccupancy, height = 475}) => {

    const occupancies = (maxOccupancy - minOccupancy) > 0 ?
        Array.from(Array(maxOccupancy - minOccupancy + 1)).map((_, index) => maxOccupancy - index)
        : [];

    return <Stack direction="column" spacing={4} mt={2} height={height}>
        <Typography textAlign="justify">
            Imposta un numero minimo di persone. Se una richiesta di prenotazione ha un
            numero inferiore di persone, il prezzo sarà calcolato utilizzando il numero minimo di persone.
        </Typography>

        <TextField type="number"
                   label="Numero minimo persone"
                   fullWidth
                   name="minPeople"
                   required
                   value={formik.values.minPeople === INDETERMINATE ? "" : formik.values.minPeople || ""}
                   onChange={formik.handleChange}
                   error={formik.touched.minPeople && Boolean(formik.errors.minPeople)}
                   helperText={formik.touched.minPeople && formik.errors.minPeople}/>

        {
            occupancies.length > 0 ?
            <>
                <Divider/>
                <Typography>
                    Imposta il prezzo per ogni numero di persone:
                </Typography>
                {
                    occupancies.filter(p => p !== basePeople).map(people => (
                        <PriceTag key={people}
                                  formik={formik}
                                  ratesViewMode={ratesViewMode}
                                  people={people}/>
                    ))
                }
            </>
            :
            <Typography>
                Numero minimo di persone maggiore o uguale alla capacità massima.
            </Typography>
        }
    </Stack>
}

export default TabOccupancy;